import BlogLanding from "./BlogLanding";
import BlogSingle from "./BlogSingle";

export {
    BlogLanding,
    BlogSingle,
}